import { MarketingConsentDetailsIdentifierType } from '@wix/ambassador-marketing-marketing-consent-v1-marketing-consent/types';
import type { OOIControllerFlowAPI } from '@wix/yoshi-flow-editor-runtime/build/cjs/flow-api/OOIController';
import { ActionType } from '../../components/PreferencesOoi/controller';

interface Props {
  flowAPI: OOIControllerFlowAPI;
  setProps: Function;
  type: MarketingConsentDetailsIdentifierType;
  shouldSubscribe?: boolean;
}

const BASE_URL = '/_api/ping-serverless/';

export const getMarketingConsent = async ({
  flowAPI,
  type,
  setProps,
}: Props) => {
  if (shouldGetDummyData(flowAPI)) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return { isSubscribed: true };
  }
  const { data } = await flowAPI.errorHandler
    .withErrorHandler(
      () =>
        flowAPI.httpClient.get<{ isSubscribed: boolean }>(
          `${BASE_URL}member-get-marketing-consent?identifierType=${type}`,
        ),
      { errorCodesMap: {} },
    )
    .then((data) => {
      return data;
    });
  return data;
};

export const setMarketingConsent = async ({
  flowAPI,
  setProps,
  type,
  shouldSubscribe,
}: Props) => {
  const { httpClient, errorHandler } = flowAPI;
  return errorHandler
    .withErrorHandler(
      () =>
        httpClient.post(`${BASE_URL}member-set-marketing-consent`, {
          shouldSubscribe,
          identifierType: type,
        }),
      { errorCodesMap: {} },
    )
    .then(() => {
      setProps({
        actionIndicator: {
          actionType: shouldSubscribe
            ? ActionType.SET_CONSENT_SUBSCRIBE
            : ActionType.SET_CONSENT_UNSUBSCRIBE,
          success: true,
        },
      });
    })
    .catch((e) => {
      setProps({
        actionIndicator: {
          actionType: shouldSubscribe
            ? ActionType.SET_CONSENT_SUBSCRIBE
            : ActionType.SET_CONSENT_UNSUBSCRIBE,
          success: false,
          error: flowAPI.errorHandler.getResolvedError(e).message,
        },
      });
    });
};

const shouldGetDummyData = (flowAPI: OOIControllerFlowAPI) =>
  flowAPI.environment.isEditor || flowAPI.environment.isPreview;
